import getBookingPackageOption from './getBookingPackageOption';

const getBookingOneWayTransport = (state, bookingReference, handle) =>
  getBookingPackageOption(
    state,
    bookingReference,
    `ONE_WAY_TRANSPORT_${handle}`,
  );

export default getBookingOneWayTransport;
